/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export function customModernizrTests() {
    (window as any).Modernizr.addTest('isios', () => {
        // const isSafari = !!$window.navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream);
    });
}
